import { COMPOSITION_GET_DATA_V3, TaxonomyType } from '@revelio/data-access';

import { RICS_TAXONOMY_ID } from '../../../../../../../shared/selection-lists/constants';
import { FilterId } from '../../../../../filters/types/filters';
import { getEntKindForGeoOrRicsLevelId } from '../../../../../filters/utils/role-skill-ent-kind';
import { levelIdsByNumber } from './level-ladder';
import type { IcicleTaxonomy } from './types';

const RICS_LEVEL_IDS = ['rics_k10', 'rics_k50', 'rics_k400'];

const RICS_ICICLE_TREE_LEVELS = [1, 2, 3];

export const industryIcicleTaxonomy: IcicleTaxonomy = {
  segment: 'rics',
  filterId: FilterId.INDUSTRY,
  overlapping: false,
  query: COMPOSITION_GET_DATA_V3,
  breakdownLevelField: 'rics_breakdown_level',
  topNField: 'rics_top_n',
  tree: {
    kind: 'reference',
    taxonomyType: TaxonomyType.Rics,
    levels: RICS_ICICLE_TREE_LEVELS,
    taxonomyId: () => RICS_TAXONOMY_ID,
  },
  levelIds: (treeLevels) =>
    levelIdsByNumber(treeLevels, RICS_ICICLE_TREE_LEVELS, RICS_LEVEL_IDS),
  rankedLevelIds: RICS_LEVEL_IDS,
  entKind: getEntKindForGeoOrRicsLevelId,
};
